const fortraders_en = require('./4traders.json')
export default fortraders_en